import tokens from '@veneer/tokens';
import rgba from 'polished/lib/color/rgba';
var chartTheme = {
  light: {
    colorChartCrosshair: tokens.color.gray3,
    colorChartLine: tokens.color.gray2,
    colorChartStartCategories: '#030061',
    colorChartEndCategories: '#ffce33',
    colorChartStartGray: tokens.color.gray3,
    colorChartEndGray: '#1d1e23',
    colorChartPositive: '#2c8f3f',
    colorChartIntermediary: '#f0c130',
    colorChartNegative: '#cf4030',
    colorChartHighlight: '#c93569',
    colorChartTooltipBackground: tokens.color.gray7,
    colorChartTooltipForeground: tokens.color.white,
    colorChartMapBubbleHalo: rgba(tokens.color.hpBlue9, 0.2),
    colorChartScrollbar: tokens.color.gray3
  },
  dark: {
    colorChartCrosshair: tokens.color.gray7,
    colorChartLine: tokens.color.gray7,
    colorChartStartCategories: '#5e57e8',
    colorChartEndCategories: '#ffde6a',
    colorChartStartGray: '#dcdde2',
    colorChartEndGray: '#1d1e23',
    colorChartPositive: '#2c8f3f',
    colorChartIntermediary: '#f0c130',
    colorChartNegative: '#cf4030',
    colorChartHighlight: '#c93569',
    colorChartTooltipBackground: tokens.color.gray2,
    colorChartTooltipForeground: tokens.color.gray10,
    colorChartMapBubbleHalo: rgba(tokens.color.hpBlue3, 0.3),
    colorChartScrollbar: tokens.color.gray6
  },
  contrast: {
    colorChartCrosshair: tokens.color.gray7,
    colorChartLine: tokens.color.gray7,
    colorChartStartCategories: '#5e57e8',
    colorChartEndCategories: '#ffde6a',
    colorChartStartGray: '#dcdde2',
    colorChartEndGray: '#1d1e23',
    colorChartPositive: '#2c8f3f',
    colorChartIntermediary: '#f0c130',
    colorChartNegative: '#cf4030',
    colorChartHighlight: '#c93569',
    colorChartTooltipBackground: tokens.color.gray2,
    colorChartTooltipForeground: tokens.color.gray10,
    colorChartMapBubbleHalo: rgba(tokens.color.hpBlue3, 0.3),
    colorChartScrollbar: 'inherit'
  }
};
export default chartTheme;